<template>
  <pui-dialog
    ref="dialog"
    transition="slide-bottom"
    width="100%"
    :show-close-button="false"
    class="file-selection-dialog file-selection-dialog__root"
    @close="close"
  >
    <template #title>
      <span class="file-selection-dialog__title-bold">{{
        $t('dam.files.selection_dialog.title')
      }}</span>
      {{ $t('dam.files.selection_dialog.subtitle', { count: initialSelectionCount }) }}
    </template>

    <div slot="dialog-action" class="dialog-action">
      <pui-button
        class="assets__reset-selection-button"
        variant="secondary"
        outline
        @click="resetSelectedItems"
      >
        {{ $t('dam.assets.reset_selection') }}
      </pui-button>
      <pui-button class="return-button" @click="close" variant="primary">
        {{ $t('dam.files.selection_dialog.button.cancel') }}
      </pui-button>
    </div>

    <template #default>
      <pui-file-assets
        :forcedSelectedFiles="selectedFiles"
        :forcedFiles="allFiles"
        :fileMode="FileMode.SELECTION"
        :initialSelectedFileCount="initialSelectionCount"
        @changeSelectedFiles="onChangeSelectedFiles"
        @resetSelectedFiles="onResetSelectedFiles"
      />
    </template>
  </pui-dialog>
</template>

<script>
import puiFileAssets, { FileMode } from './FileAssets';

export default {
  components: {
    puiFileAssets,
  },
  data() {
    return {
      /**
       * Our own selected files
       */
      selectedFiles: [],
      /**
       * All the files that were originally selected
       */
      allFiles: [],
      // OTHER
      FileMode,
    };
  },
  computed: {
    /**
     * @returns {number} the original count of selected files
     */
    initialSelectionCount() {
      return this.allFiles.length;
    },
  },
  methods: {
    /**
     * Opens the dialog
     *
     * @param {object[]} selectedFiles - the array of selected files to display
     * @returns {void}
     */
    open(selectedFiles) {
      this.$refs.dialog.open();

      this.selectedFiles = [...selectedFiles];
      this.allFiles = [...selectedFiles];
    },
    /**
     * Closes the dialog and resets variables
     * @returns {void}
     */
    close() {
      this.$refs.dialog.close();
      this.selectedFiles = [];
      this.allFiles = [];
    },
    // FILES
    /**
     * Updates the selected files when the selection changes
     *
     * @param {object[]} selectedFiles - the new array of selected files
     * @returns {void}
     */
    onChangeSelectedFiles(selectedFiles) {
      this.selectedFiles = selectedFiles;
      // We don't emit an event here, because we want to modify the
      // selection state only locally to our component
    },
    /**
     * Clears the selected files and emits 'resetSelectedFiles'
     *
     * @returns {void}
     */
    onResetSelectedFiles(selectedFiles) {
      this.selectedFiles = [];
      // Emit an event, because we want the parent to handle
      // how to clear the original selection
      this.$emit('resetSelectedFiles');
    },
    /**
     * Clears the selected files
     *
     * @returns {void}
     * */
    resetSelectedItems() {
      this.selectedFiles = [];
      this.$emit('resetSelectedFiles');

      this.refreshSelectionForm();
    },
    /**
     * Updates the selection form
     *
     * @returns {void}
     */
    refreshSelectionForm() {
      // Wait for details panel to receive new files via props
      this.$nextTick(() => {
        if (this.$refs.detailsPanel) {
          this.$refs.detailsPanel.refreshSelectionForm();
        }
      });
    },
  },
};
</script>
